// Copyright 2025. WebPros International GmbH. All rights reserved.

export const GLOBAL_VS_BACKUP_SETTINGS_CARD = {
    SWITCH: 'global-vs-backup-settings-switch',
};
